import { MessageService } from 'primeng/api';
import { Component, NgModule, Input, OnInit, ChangeDetectorRef, Output, EventEmitter, OnDestroy} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, FormGroup, ReactiveFormsModule, FormArray, Validators, FormControl} from '@angular/forms';
import { BaseFormComponent } from '../../../../models/base/base-form.component';
import { SimpleControlModule } from '../dynamic/simple-control.component';
import { FormHelperService } from '../../../../../src/services/form-helper.service';
import { DynamicDateFormModule } from '../dynamic-date-form.componet';
import { LoadingModule } from '../loading.component';
import { UserService } from '../../../../../src//services/user.service';
import { DynamicValueModule } from '../dynamic/dynamic-value.component';
import { DynamicControlErrorModule } from '../dynamic/dynamic-control-error.component';
import { FileService } from '../../../../../src/services/file.service';
import { LookupService } from '../../../../../src/services/lookup.service';
import { UploadsComponent, UploadsModule } from '../uploads.component';
import { DialogModule } from 'primeng/dialog';
import { SharedService } from '../../../../../src/services/shared.service';
import { NavigationService } from '../../../../../src/services/navigation.service';
import { InvoiceService } from '../../../../../src/services/invoice.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'accounting-dynamic-bulk-upload',
  templateUrl: './accounting-dynamic-bulk-upload.component.html',
  providers: [InvoiceService, UserService, FileService, LookupService]
})
export class AccountingDynamicBulkUploadComponent extends BaseFormComponent implements OnInit , OnDestroy {

  @Input() invoices: any[] = []
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSaveComplete: EventEmitter<any> = new EventEmitter<any>();

  declare form: FormGroup;
  dynamicBulkUploadrray: FormArray = null;
  isLoading: boolean = false;
  invoiceIds = [];
  uploads: any[] = [];
  startTime: number;
  totalTime: number = 2700;
  modal = null;
  metadata: any = {};
  showfscPaidByOther : boolean[] = [];
  showCancelWarningDailog = false;
  totalBalanceDue = 0;
  showValidationFlags: boolean[] = [];
  validInvoice:boolean = false;
  private destroy$ = new Subject<void>();

  constructor(protected messageService: MessageService, private invoiceService: InvoiceService, private fh: FormHelperService, private ref: ChangeDetectorRef, private lookupService: LookupService, private datePipe: DatePipe, private navigationService: NavigationService , private sharedService:SharedService) {
    super();
  }

  ngOnInit() {
    this.isLoading = true;
    this.loadLookup("yesNoNa");
    this.loadLookup("paymentMethod");
    this.loadLookup("fscpaidbycustomer");
    if (this.invoices.length > 0) {
      this.invoiceIds = this.invoices.map((res) => res.id);
      this.invoiceService
        .getAccountingBulkEdit(this.invoiceIds)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.modal = res.body.result.invoiceDetails;
          this.metadata = res.body.result.metadata;
          this.load(res.body.result.invoiceDetails);
          this.calculateBalanceDue(this.modal);
          this.bulkEditInvoice.controls.forEach((control,index) => {
            control.valueChanges.subscribe((value) => {
              this.paymentChanged(index)
            });
          });

          this.isLoading = false;
          this.startTime = Date.now();
          this.timer();
          this.ref.markForCheck();
        });
    }
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService
      .get(key, force)
      .pipe(takeUntil(this.destroy$))
      .subscribe((r: any) => {
        this.lookups[key] = r;
      });
  }

  timer() {
    const currentTime = Date.now();
    const elapsedTime = (currentTime - this.startTime) / 1000;
    this.totalTime -= elapsedTime;

    if (this.totalTime <= 0) {
      this.totalTime = 0;
      this.cancel();
    }

    this.startTime = currentTime;

    if (this.totalTime > 0) {
      requestAnimationFrame(() => this.timer());
    }
  }

  paymentChanged(i: number) {
    let f = (this.form.get("bulkEditInvoice") as FormArray).controls;
    if (f[i].get("invoicePaid").value == 1) {
      // partial
      f[i].get("partialAmountPaid").setValidators([Validators.required]);
      this.showValidationFlags[i] = true;
    } else {
      f[i].get("partialAmountPaid").setValue(null, { emitEvent: false });
      f[i].get("partialAmountPaid").clearValidators();
      this.showValidationFlags[i] = false;
    }
    if (f[i].get("invoicePaid").value == 3 || f[i].get("invoicePaid").value == 5) {
      f[i].get("fscPaidDate").clearValidators();
      f[i].get("fscPaidBy").clearValidators();
      f[i].get("fscPaidDate").setValue(null, { emitEvent: false });
      f[i].get("fscPaidBy").setValue(null, { emitEvent: false });
    } else {
      f[i].get("fscPaidDate").setValidators([Validators.required]);
      f[i].get("fscPaidBy").setValidators([Validators.required]);
    }
    if (f[i].get("fscPaidBy").value == 8) {
      this.showfscPaidByOther[i] = true;
    } else {
      this.showfscPaidByOther[i] = false;
      f[i].get("fscPaidByOther").setValue(null, { emitEvent: false });
    }
    if (
      f[i].get("fscPaidBy").value ||
      f[i].get("fscPaidDate").value ||
      f[i].get("invoicePaid").value === 1 ||
      f[i].get("invoicePaid").value === 2
    ) {
      f[i].get("fscPaidBy").setValidators([Validators.required]);
      f[i].get("fscPaidDate").setValidators([Validators.required]);
      f[i].get("invoicePaid").setValidators([Validators.required]);
    } else {
      f[i].get("fscPaidBy").clearValidators();
      f[i].get("fscPaidDate").clearValidators();
      f[i].get("invoicePaid").clearValidators();
    }
    this.validInvoice = this.showValidationFlags.every((x) => x == false);
    f[i].get("partialAmountPaid").updateValueAndValidity({ emitEvent: false });
    f[i].get("fscPaidDate").updateValueAndValidity({ emitEvent: false });
    f[i].get("fscPaidBy").updateValueAndValidity({ emitEvent: false });
    f[i].get("invoicePaid").updateValueAndValidity({ emitEvent: false });
  }


  displayTimer(): string {
    const minutes = Math.floor(this.totalTime / 60);
    const seconds = Math.floor(this.totalTime % 60);

    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds.toString();
    return `${formattedMinutes}:${formattedSeconds}`;
  }

  changeUploads(rows: any[]) {
    if (rows == null)
      return;
    rows.forEach(x => x.id = 0);
    this.uploads = rows.filter(r => r.id != null);
  }

  load(model: any) {
    this.form = new FormGroup({}, []);
    let bulkEditForm = [];
    if (model?.length > 0) {
      model?.forEach(r => {
        bulkEditForm.push(this.fh.getDynamicBulkUploadForInvoice(r));
      });
    }
    this.form?.addControl("bulkEditInvoice", new FormArray(bulkEditForm));
    this.form?.addControl("total",  new FormControl(null, [Validators.required]));
    this.showValidationFlags = model?.map(item => item?.invoicePaid == 1) || [];
    this.showfscPaidByOther = model?.map(item => item?.fscPaidBy == 8) || [];
    this.validInvoice = (this.showValidationFlags.every((x)=>x==false));
    this.form.markAllAsTouched();
    this.ref.detectChanges();
  }

  cancel() {
    this.form = new FormGroup({}, []);
    this.ref.markForCheck();
    this.onCancel.emit(this.invoiceIds);
    this.sharedService.getMenuCount("invoice").subscribe((res) => {
      this.navigationService.menuCountChange(res.body, "invoice");
    });
    this.navigationService.clickCancelInvoiceBulkButton(true);
  }

  cancelClick() {
    if (this.form?.dirty) {
      this.showCancelWarningDailog = true;
    } else {
      this.showCancelWarningDailog = false;
      this.cancel();
    }
  }

  get bulkEditInvoice(): FormArray {
    return this.form?.get("bulkEditInvoice") as FormArray;
  }

  get showWarning(): boolean {
    return this.form?.valid  && this.totalBalanceDue > this.form?.get('total')?.value && this.validInvoice && !this.allUncollectible;
  }

  calculateBalanceDue(invoiceData: any) {
    for (let invoice of invoiceData) {
      this.totalBalanceDue += invoice.balanceDue;
    }
  }

  setDateFormat(date: any) {
    return this.datePipe.transform(date, 'MM/dd/yyyy', 'UTC');
  }

  save() {
    this.isLoading = true;
    const f = this.form?.value;
    f.attachments = this.uploads;
    f.invoiceids = this.invoiceIds;
    f.bulkEditInvoice.forEach((res) => {
      if (res.fscPaidDate) {
        res.fscPaidDate = this.datePipe.transform(res.fscPaidDate, 'yyyy-MM-dd');
      }
    })
    this.invoiceService.saveAccountingBulkEdit(f).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res?.body) {
        this.messageService.add(this.toast(true, res?.body));
      } else {
        this.messageService.add(this.toast(true, 'Bulk Invoice edit successfully'));
      }
      this.cancel();
    }, err => {
      this.isLoading = false;
      this.ref.markForCheck();
      if (err?.error?.message != null) {
        this.messageService.add(this.toast(true, err.error.message));
      } else if (err?.status == 500) {
        this.messageService.add(this.toast(true, 'Internal Server Error'));
      }
    })
  }


applyValuesToAll(): void {
  const formArray = this.bulkEditInvoice;
  if (!formArray || formArray.length < 2) return;

  const { orderId, number, ...restValues } = formArray.at(0).value;

  const shouldShowValidation = this.showValidationFlags[0] === true;
  const shouldShowFscPaidByOther = this.showfscPaidByOther[0] === true;

  for (let i = 1; i < formArray.length; i++) {
    this.showValidationFlags[i] = shouldShowValidation;
    this.showfscPaidByOther[i] = shouldShowFscPaidByOther;
    formArray.at(i).patchValue(restValues, { emitEvent: false });
  }

  formArray.controls.forEach((control) =>
    control.updateValueAndValidity({ emitEvent: false })
  );

  this.validInvoice = this.showValidationFlags.every((x) => x == false);

  this.ref.detectChanges();
}

get isFirstInvoiceValid(): boolean {
  if (!this.bulkEditInvoice || this.bulkEditInvoice.length === 0) return false;
  const first = this.bulkEditInvoice.at(0);
  if (
    first.get("invoicePaid")?.value == 3 ||
    first.get("invoicePaid")?.value == 4 ||
    first.get("invoicePaid")?.value == 5
  ) {
    return true;
  }
  return first.get('invoicePaid')?.value && first.get('fscPaidBy')?.value && first.get('fscPaidDate')?.value && this.bulkEditInvoice.at(0).valid;
}

get allUncollectible(): boolean {
   return this.bulkEditInvoice?.controls?.every((inv: any) => inv.get('invoicePaid')?.value == 5);
}
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

@NgModule({
  declarations: [
    AccountingDynamicBulkUploadComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SimpleControlModule,
    DynamicDateFormModule,
    LoadingModule,
    DynamicValueModule,
    DynamicControlErrorModule,
    UploadsModule,
    DialogModule
  ],
  exports: [
    AccountingDynamicBulkUploadComponent,
    UploadsComponent
  ]
})
export class AccountingDynamicBulkUploadModule { }
